import type { IChartData } from "../../dashboard/types";

export type CategoriaDoPeriodo = "CALLS" | "WEBSITE" | "DIRECTIONS" | "VIEWS";

export const PERIODOS = [
  { dias: 7, rotulo: "7 dias" },
  { dias: 15, rotulo: "15 dias" },
  { dias: 30, rotulo: "30 dias" },
  { dias: 60, rotulo: "60 dias" },
  { dias: 90, rotulo: "90 dias" },
  { dias: 180, rotulo: "6 meses" },
  { dias: 365, rotulo: "1 ano" },
] as const;

type AnoDeGrafico = { year: number; categories: Record<string, Record<string, number> | undefined> };

const valorDoMes = (anos: AnoDeGrafico[], categoria: CategoriaDoPeriodo, data: Date): number => {
  const ano = anos.find((item) => item.year === data.getFullYear());
  if (!ano) return 0;
  const chave = String(data.getMonth() + 1).padStart(2, "0");
  if (categoria === "VIEWS") {
    return (ano.categories.DESKTOP?.[chave] ?? 0) + (ano.categories.MOBILE?.[chave] ?? 0);
  }
  return ano.categories[categoria]?.[chave] ?? 0;
};

/**
 * Variação do período contra o período imediatamente anterior, em meses
 * fechados do gráfico mensal — o mês corrente fica de fora porque ainda está
 * incompleto e sempre "cairia". Sem base anterior devolve null: o card mostra
 * "sem base de comparação" em vez de inventar um número.
 */
export const variacaoDoPeriodo = (
  chartData: IChartData | null | undefined,
  categoria: CategoriaDoPeriodo,
  dias: number,
  hoje: Date = new Date(),
): number | null => {
  if (!chartData) return null;
  const anos = (categoria === "VIEWS" ? chartData.viewsChart : chartData.clicksChart) as unknown as AnoDeGrafico[];
  if (!anos?.length) return null;
  const meses = Math.max(1, Math.ceil(dias / 30));
  let atual = 0;
  let anterior = 0;
  for (let i = 1; i <= meses; i += 1) {
    atual += valorDoMes(anos, categoria, new Date(hoje.getFullYear(), hoje.getMonth() - i, 1));
    anterior += valorDoMes(anos, categoria, new Date(hoje.getFullYear(), hoje.getMonth() - i - meses, 1));
  }
  if (anterior <= 0) return null;
  return Math.round(((atual - anterior) / anterior) * 100);
};

/** Regra do produto: no relatório do cliente ativo só a variação positiva aparece. */
export const seloDeVariacao = (
  variacao: number | null,
  opcoes: { mostrarQueda?: boolean; meses?: number } = {},
): string | null => {
  if (variacao === null) return null;
  const base = opcoes.meses === 1 ? "vs. mês anterior" : "vs. período anterior";
  if (variacao > 0) return `+${variacao}% ${base}`;
  if (variacao < 0 && opcoes.mostrarQueda) return `${variacao}% ${base}`;
  return null;
};
